module.exports = __webpack_public_path__ + "static/img/null-data.d66f0d3e.png";